export const FRRSCA_BASE_URL = "https://frrsca-backend.khanysorn.me"